import { MissionsStyles } from './MissionsStyles'
import React, { useEffect, useState } from 'react'
import Text from '../../../../components/text/Text'
import SvgIcon from '../../../../components/svgIcon/SvgIcon'
import { getHomeMissions } from '../../../../services/amipos'
import { ProgressBarComponent } from '../../../../components/progressBar/ProgressBarComponent'

interface ResponseDataType {
    configurationTypeColor: string
    buttonColor: string
    configurationTypeText: string
    title: string
    subtitle: string
    estimatedTimeText: string
    buttonText: string
    type: string
    link: string
    completed: boolean
}

export function MissionsComponent() {
    const [data, setData] = useState<ResponseDataType[]>([])

    useEffect(() => {
        getHomeMissions()
            .then(async (success) => {
                // setData(success.data.map((i: ResponseDataType) => i))
                setData([])
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    const getProgress = () => {
        const total = data.length
        const done = data.filter((i) => i.completed).length

        return { p: (done * 100) / total, total, done }
    }

    const handlerPress = () => {
        console.log()
    }

    if (data.length === 0) return null

    return (
        <div style={MissionsStyles.container}>
            <div style={MissionsStyles.top}>
                <div style={MissionsStyles.topTitle}>
                    <Text
                        label="Tus misiones:"
                        fontWeight={400}
                        marginRight={10}
                        color="#184287"
                        fontSize={27}
                    />
                </div>
                <div style={MissionsStyles.topProgressContainer}>
                    <ProgressBarComponent width={getProgress().p} />
                </div>
                <div style={MissionsStyles.topRightContainer}>
                    <div style={MissionsStyles.topStepContent}>
                        <Text
                            fontSize={15}
                            label={`${getProgress().done} de ${
                                getProgress().total
                            }`}
                            color="#5154588C"
                            fontWeight={600}
                        />
                    </div>
                    <div style={MissionsStyles.topRightTextContent}>
                        <Text
                            fontSize={9}
                            fontWeight={600}
                            color="#5154588C"
                            label="Completa tus misiones para impulsar tu negocio."
                        />
                    </div>
                </div>
            </div>
            <div style={MissionsStyles.content}>
                {data.map((item, index) => (
                    <button
                        key={index}
                        onClick={handlerPress}
                        style={MissionsStyles.btnContent}
                    >
                        <div style={MissionsStyles.btnHeader}>
                            <div style={MissionsStyles.btnIcon}>
                                <SvgIcon
                                    width={20}
                                    height={20}
                                    iconName="IconObject"
                                />
                            </div>
                            <Text
                                color={`#${item.configurationTypeColor}`}
                                label={item.configurationTypeText}
                                fontWeight={600}
                                fontSize={9}
                            />
                        </div>
                        <div style={MissionsStyles.btnBody}>
                            <Text
                                label={item.estimatedTimeText}
                                marginBottom={10}
                                fontWeight={300}
                                color="#656565A1"
                                fontSize={9}
                            />
                            <Text
                                label={item.title}
                                marginBottom={10}
                                fontWeight={600}
                                color="#656565"
                                fontSize={21}
                            />
                            <Text
                                label={item.subtitle}
                                fontWeight={600}
                                color="#5154588C"
                                fontSize={9}
                            />
                        </div>
                        <div style={MissionsStyles.btnFooter}>
                            <button
                                style={{
                                    ...MissionsStyles.btnAction,
                                    borderColor: `#${item.buttonColor}`,
                                }}
                            >
                                <Text
                                    color={`#${item.buttonColor}`}
                                    label={item.buttonText}
                                    fontWeight={600}
                                    fontSize={11}
                                />
                            </button>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    )
}
